import { createApp, ref, provide } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import UserSetting from '@/src/javascripts/layout/UserSetting.vue'

$(document).on('turbo:load turbo:render', () => {
  const pageHeader = document.querySelector('#page-header')
  if (pageHeader && !pageHeader.__vue_app__) {
    const isUserSettingShow = ref(false)
    const openUserSetting = () => {
      isUserSettingShow.value = true
    }

    createApp({
      components: { BaseAlert, UserSetting },
      setup () {
        provide('isUserSettingShow', isUserSettingShow)
        return {
          isUserSettingShow,
          openUserSetting
        }
      }
    }).mount(pageHeader)
  }
})
